import React, { Fragment } from 'react';
import { DatePicker, Form, Input, Row, Col, Button, Checkbox } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { withRouter } from 'dva/router';
import PropTypes from 'prop-types';
import { CancelToken } from 'axios';
import helpers from '../../../utils/helpers';
import styles from '../styles.less';
import { RemoteSelectInput, SelectInput } from '../../../components';
import {
  branchesSearchRequest,
  searchClassificationCodes2ndLevelRequest,
} from '../../../services/branches';
import { defaultFiltersConfig, defaultFilterState } from '../../../utils/dataFilter';
import { WithHubspotProjectPermissions } from '../../Permissions';

const FormItem = Form.Item;
const Search = Input.Search;
const RangePicker = DatePicker.RangePicker;

class LeadsCompaniesFilter extends React.Component {
  static propsTypes = {
    customBranches: PropTypes.string.isRequired, // the property filter used
    projectId: PropTypes.string.isRequired,
    showClearFilters: PropTypes.bool.isRequired,
    formFields: PropTypes.object.isRequired, // filter form fields
  }

  constructor(props) {
    super(props);

    this.state = {
      showKompassBranches: false,
      additionalFiltersHidden: true,
      allLeadMarks: [],
      isFilterModalOpen: false,
    };
  }

  componentDidMount() {
    this.props.dispatch({ type: 'countries/loadList' });
    this.props.dispatch({ type: 'leadLabels/loadList' }).then(({ data }) => this.setState({ allLeadMarks: data }));
  }

  clearFilters(e) {
    e.preventDefault();
    this.props.form.resetFields();
    this.props.onChange(defaultFilterState);
  }

  filterChange = () => {
    setTimeout(() => {
      const currentFilters = this.props.form.getFieldsValue();
      currentFilters.isDefaultFilters = false;
      this.props.onChange(currentFilters);
    });
  }

  toggleFilters = () => {
    this.setState({
      additionalFiltersHidden: !this.state.additionalFiltersHidden,
    });
  }

  toggleFiltersModal = () => {
    this.setState({
      isFilterModalOpen: !this.state.isFilterModalOpen,
    });
  }

  branchesLoader = (query) => {
    let cancel;

    const queryPart = this.props.customBranches ?
      { filter: { name: `*${query}*` } } :
      { filter: { label: `*${query}*` } };

    const requestConfig = {
      cancelToken: new CancelToken((c) => {
        cancel = c;
      }),
    };

    const request = this.props.customBranches ?
      branchesSearchRequest(queryPart, requestConfig) :
      searchClassificationCodes2ndLevelRequest(queryPart, requestConfig);

    return {
      request,
      cancel,
    };
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      companyName,
      dateRange,
      leadMarks,
      countries,
      city,
      branches,
      companyVisibility,
      isFilterDefault,
    } = this.props.companies.filter || [];

    return (
      <Form className={styles.targetGroup}>
        <Button
          className={`${styles.withIcon} filter-toggle`} size="large" type="primary"
          onClick={this.toggleFiltersModal}
        >
          <FormattedMessage id="Component.LeadsVisitsFilter.FilterAndSort" />
          <i className={[styles.btnIcon, styles.iconFilters].join(' ')} />
        </Button>
        <div className={`filter-main ${this.state.isFilterModalOpen ? 'open' : ''}`}>
          <div className="filter-main-inner">
            <h2 className="filter-title">
              <FormattedMessage id="Component.LeadsVisitsFilter.FilterAndSort" />
            </h2>
            <Button className={`${styles.withIcon} filter-modal-close`} onClick={this.toggleFiltersModal}>
              <i className={[styles.btnIcon, styles.iconFiltersClose].join(' ')} />
            </Button>
            <Row gutter={10} type="flex" align="top">
              <Col style={{ flex: 1 }}>
                <div className={styles.filterComapniesGrid}>
                  <div className="filter-grid__column">
                    <FormItem colon={false}>
                      {getFieldDecorator('dateRange', {
                        onChange: this.filterChange,
                        initialValue: dateRange,
                        required: true,
                      })(
                        <RangePicker allowClear={false} format={this.props.dateFormat} />,
                      )}
                    </FormItem>
                  </div>
                  <div className="filter-grid__column">
                    <FormattedMessage id="Component.LeadsVisitsFilter.Country">
                      {msg => (
                        <FormItem colon={false}>
                          {getFieldDecorator('countries', {
                            initialValue: countries,
                          })(
                            <SelectInput
                              showArrow
                              onBlur={this.filterChange}
                              onDeselect={this.filterChange}
                              mode="multiple"
                              placeholder={msg}
                              options={this.props.countries && this.props.countries.countriesList}
                              filterOption={helpers.multipleSelectFilter}
                            />,
                          )}
                        </FormItem>
                      )}
                    </FormattedMessage>
                  </div>
                  <div className="filter-grid__column">
                    <FormattedMessage id="Component.LeadsVisitsFilter.City">
                      {msg => (
                        <FormItem colon={false}>
                          {getFieldDecorator('city', {
                            initialValue: city,
                          })(
                            <Search
                              maxLength={255}
                              onSearch={this.filterChange}
                              placeholder={msg}
                            />,
                          )}
                        </FormItem>
                      )}
                    </FormattedMessage>
                  </div>
                  <div className="filter-grid__column">
                    <FormattedMessage id="Component.LeadsVisitsFilter.Label">
                      {msg => (
                        <FormItem colon={false}>
                          {getFieldDecorator('leadMarks', {
                            initialValue: leadMarks,
                          })(
                            <SelectInput
                              showArrow
                              onBlur={this.filterChange}
                              onDeselect={this.filterChange}
                              mode="multiple"
                              placeholder={msg}
                              filterOption={helpers.multipleSelectFilter}
                              options={this.state.allLeadMarks}
                            />,
                          )}
                        </FormItem>
                      )}
                    </FormattedMessage>
                  </div>
                  {!this.state.additionalFiltersHidden &&
                    <Fragment>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.Branch">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('branches', {
                                initialValue: branches,
                              })(
                                <RemoteSelectInput
                                  labelInValue
                                  nameKey={this.props.customBranches ? 'name' : 'label'}
                                  remoteLoader={this.branchesLoader}
                                  showArrow
                                  onBlur={this.filterChange}
                                  onDeselect={this.filterChange}
                                  mode="multiple"
                                  placeholder={msg}
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.CompanyNameSearch">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('companyName', {
                                initialValue: companyName,
                              })(
                                <Search
                                  maxLength={255}
                                  onSearch={this.filterChange}
                                  placeholder={msg}
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.CompanyVisibilityPlaceholder">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('companyVisibility', {
                                initialValue: companyVisibility,
                                onChange: this.filterChange,
                              })(
                                <SelectInput
                                  placeholder={msg}
                                  options={defaultFiltersConfig.allCompanyVisibilityFilters}
                                  idKey="value"
                                  nameKey="label"
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <WithHubspotProjectPermissions>
                        <div className="filter-grid__column">
                          <FormattedMessage id="Component.LeadsVisitsFilter.HubspotTask">
                            {msg => (
                              <FormItem colon={false}>
                                {getFieldDecorator('hubspotTransfer', {
                                  onChange: this.filterChange,
                                })(
                                  <SelectInput
                                    placeholder={msg}
                                    options={defaultFiltersConfig.hubspotTaskFilters}
                                    idKey="value"
                                    nameKey="label"
                                  />,
                                )}
                              </FormItem>
                            )}
                          </FormattedMessage>
                        </div>
                      </WithHubspotProjectPermissions>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.Source">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('lastSource', {
                                initialValue: this.props.formFields.source,
                              })(
                                <SelectInput
                                  showArrow
                                  onBlur={this.filterChange}
                                  onDeselect={this.filterChange}
                                  mode="multiple"
                                  placeholder={msg}
                                  filterOption={helpers.multipleSelectFilter}
                                  options={defaultFiltersConfig.allSources}
                                  nameKey="label"
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.Campaign">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('lastCampaignKeyword', {
                                initialValue: this.props.formFields.campaign,
                              })(
                                <Search
                                  maxLength={255}
                                  onSearch={this.filterChange}
                                  placeholder={msg}
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                      <div className="filter-grid__column">
                        <FormattedMessage id="Component.LeadsVisitsFilter.CampaignName">
                          {msg => (
                            <FormItem colon={false}>
                              {getFieldDecorator('lastCampaignName', {
                                initialValue: this.props.formFields.campaignName,
                              })(
                                <Search
                                  maxLength={255}
                                  onSearch={this.filterChange}
                                  placeholder={msg}
                                />,
                              )}
                            </FormItem>
                          )}
                        </FormattedMessage>
                      </div>
                    </Fragment>
                  }
                </div>
                {!this.state.additionalFiltersHidden &&
                  <Row gutter={10} type="flex" align="top" justify="start" className={styles.filters}>
                    {this.props.customBranches &&
                      <Col>
                        {getFieldDecorator('showKompassBranches', {
                          initialValue: this.state.showKompassBranches,
                          valuePropName: 'checked',
                          onChange: (e) => {
                            this.props.showKompassBranches(e.target.checked);
                            this.setState({ showKompassBranches: e.target.checked });
                          },
                        })(
                          <Checkbox>
                            <FormattedMessage id="Component.LeadsVisitsFilter.ShowKompassBranches" />
                          </Checkbox>,
                        )}
                      </Col>}
                  </Row>
                }
              </Col>
              <Col style={{ flex: 0 }}>
                <Row>
                  <Col>
                    <Button
                      className={[styles.btnMoreLessFilters].join(' ')}
                      onClick={this.toggleFilters}
                      type="primary"
                      size="large"
                      shape="circle"
                      icon={this.state.additionalFiltersHidden ? 'plus' : 'minus'}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row type="flex" justify="space-between">
              <Col>
                {!isFilterDefault &&
                  <a
                    href="#" className={[styles.btnNoBorder, styles.clearAllBtn].join(' ')}
                    onClick={this.clearFilters.bind(this)}
                  >
                    <FormattedMessage id="Component.LeadsVisitsFilter.ClearAllFilters" />
                  </a>}
              </Col>
            </Row>
          </div>
        </div>
      </Form>
    );
  }
}

export default withRouter(connect(({ leads, countries, companies, user }) => ({
  leads,
  countries,
  companies,
  user,
}))(Form.create()(injectIntl(LeadsCompaniesFilter))));



// WEBPACK FOOTER //
// ./src/components/Leads/LeadsCompaniesFilter/LeadsCompaniesFilter.js